/* ============================================================================
   SLURPPED — shared UK postcode zone check
   ----------------------------------------------------------------------------
   ONE copy of the delivery geography, used by the signup forms to tell a new
   subscriber whether we can actually reach them.

   🔴 THE RULES BELOW ARE DUPLICATED IN `sections/slurpped-buy-zone.liquid`
   (PC_FULL_BLOCK / pcParse / pcBlocked / PC_LOCAL). That duplication is
   TEMPORARY AND DELIBERATE: the buy zone gates purchasing and ships its CTA
   fail-closed, and it was not worth refactoring in launch week to add a signup
   field. `test/postcode-parity.test.js` extracts BOTH copies and asserts they
   agree on several thousand postcodes, so they cannot drift silently.
   THE FOLLOW-UP IS TO POINT THE BUY ZONE AT THIS FILE AND DELETE ITS COPY.

   Geography is encoded 1:1 from the delivery-area spec. Never guess it.
   ========================================================================== */
(function (w) {
  'use strict';

  var FULL_BLOCK = { BT: 1, IM: 1, HS: 1, ZE: 1, KW: 1, IV: 1, GY: 1, JE: 1 };
  var PC_RE = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/;

  function inRanges(d, ranges) {
    for (var i = 0; i < ranges.length; i++) {
      if (d >= ranges[i][0] && d <= ranges[i][1]) return true;
    }
    return false;
  }

  function parse(v) {
    var pc = (v || '').toUpperCase().replace(/\s+/g, '');
    if (!PC_RE.test(pc)) return null;
    var outward = pc.slice(0, -3); // the inward code is always the last 3 chars
    var area = (outward.match(/^[A-Z]+/) || [''])[0];
    var district = parseInt((outward.slice(area.length).match(/^\d+/) || ['0'])[0], 10);
    return { area: area, district: district, outward: outward, pc: pc };
  }

  function blocked(area, district) {
    if (FULL_BLOCK[area]) return true;
    if (area === 'KA') return district === 27 || district === 28;
    if (area === 'PO') return district >= 30 && district <= 41;
    if (area === 'TR') return district >= 21 && district <= 25;
    if (area === 'AB') return !inRanges(district, [[1, 16], [21, 25], [30, 30], [39, 39]]);
    if (area === 'PA') return !(district >= 1 && district <= 19);
    if (area === 'PH') return !(district >= 1 && district <= 3);
    return false; // England & Wales + lowland Scotland + the allowed AB/PA/PH/KA
  }

  /* Which districts are close enough to collect from Hanham. Comes from a
     setting, never a hard-code: a bare area (BS) is every district in it,
     BS15 is one, BS1-BS16 an inclusive range. Anything unparseable is dropped
     silently, so a typo can only ever NARROW the catchment, never widen it. */
  function parseLocal(raw) {
    var out = [];
    String(raw || '').split(',').forEach(function (tok) {
      var m = tok.trim().toUpperCase().match(/^([A-Z]{1,2})(?:(\d{1,2})(?:\s*-\s*[A-Z]{0,2}(\d{1,2}))?)?$/);
      if (!m) return;
      var from = m[2] === undefined ? 0 : parseInt(m[2], 10);
      var to = m[3] !== undefined ? parseInt(m[3], 10) : (m[2] === undefined ? 99 : from);
      if (to < from) { var sw = from; from = to; to = sw; }
      out.push({ area: m[1], from: from, to: to });
    });
    return out;
  }

  function isLocal(area, district, local) {
    for (var i = 0; i < local.length; i++) {
      if (local[i].area === area && district >= local[i].from && district <= local[i].to) return true;
    }
    return false;
  }

  /* The one function the forms call.
     -> { ok:false, reason:'format' }            not a real UK postcode
     -> { ok:true, zone:'collect'|'deliver'|'none', district:'BS15' }

     🔒 We return and store the OUTWARD DISTRICT ONLY (BS15), never the full
     postcode. A full UK postcode narrows to roughly fifteen households; the
     district is all we need to answer "can we reach you", so storing more
     would fail the data-minimisation test for no gain. */
  function check(value, localRaw) {
    var p = parse(value);
    if (!p) return { ok: false, reason: 'format' };
    var zone = 'deliver';
    if (blocked(p.area, p.district)) zone = 'none';
    else if (isLocal(p.area, p.district, parseLocal(localRaw))) zone = 'collect';
    return { ok: true, zone: zone, district: p.outward, area: p.area };
  }

  w.SlurppedPostcode = {
    check: check,
    parse: parse,
    blocked: blocked,
    parseLocal: parseLocal,
    isLocal: isLocal
  };
})(window);
